import { memo } from 'react';

// import Router from 'next/router';

import { connect } from 'react-redux';

// const goBack = () => {
//   Router.back();
// };

//  <div className='d-md-none d-inline-block' onClick={goBack}>
//       <img src='/images/arrow-circle-left.svg' height={24} width={24} />
//       <span className='black font-14px semi-bold ml-2'>Back</span>
//     </div>
//     <button className='bg-black border-0 br-8 back_button text-left pl-4 center-y d-none d-md-block' onClick={goBack}>
//       <img src='/images/arrow-left-white.svg' height={24} width={24} />
//       <span className='white font-16px semi-bold ml-3'>Back</span>
//     </button>
//     <style jsx>{`
//       .back_button {
//         width: 126px;
//         height: 40px;
//       }
//     `}</style>

const BackButton = memo(() => null);

BackButton.displayName = 'BackButton';

const mapStateToProps = ({ currentUser }) => ({
  currentUser
});

export default connect(mapStateToProps, {})(BackButton);
